import { useState } from 'react';
import mixpanel from 'mixpanel-browser';
import qs from 'qs';

export const useGoogleBusinessProfile = (businessDetailsCompleted, currentShop) => {
	const [gbpLoading, setGbpLoading] = useState(false);
	const [gbpError, setGbpError] = useState(null);
	const [pollingForGBPConnection, setPollingForGBPConnection] = useState(false);

	// GBP is complete when connection status is 'connected'
	const gbpCompleted = currentShop?.gmbConnection?.status === 'connected';

	const handleConnectGBP = () => {
		if (!currentShop?.legacyId) {
			setGbpError('Unable to connect - shop configuration issue. Please contact support.');
			return;
		}

		// Track GBP connect started
		mixpanel.track('Unify GBP connect started', {
			distinct_id: currentShop.id
		});

		setGbpError(null);
		setGbpLoading(true);

		// Build OAuth URL with silent mode and custom redirectUrl
		// ⚠️ CRITICAL: Use legacyId (numeric), NOT shopId (UUID)
		const queryString = qs.stringify({
			id: currentShop.legacyId,
			silent: 'true',
			redirectUrl: `${window.location.origin}/unify-onboarding?gbp_callback=true`
		});

		const oauthUrl = `https://connect.near.live/api/uri?${queryString}`;

		// Redirect to GMB Connect OAuth flow
		window.location.href = oauthUrl;
	};

	return {
		gbpCompleted,
		gbpLoading,
		gbpError,
		pollingForGBPConnection,
		handleConnectGBP,
		setGbpError,
		setGbpLoading,
		setPollingForGBPConnection
	};
};
